import React from 'react';

import { cn } from '@/utils/classname';

export interface SettingContentCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Card content */
  children: React.ReactNode;
  /** Additional className for customization */
  className?: string;
  /** Padding size variant */
  padding?: 'sm' | 'md' | 'lg';
}

/**
 * Standardized bordered card container for settings content
 *
 * Provides consistent border, background, and padding across all settings cards
 *
 * @example
 * ```tsx
 * <SettingContentCard padding="md" data-testid="my-card">
 *   <div>Your settings content here</div>
 * </SettingContentCard>
 * ```
 */
export const SettingContentCard: React.FC<SettingContentCardProps> = ({
  children,
  className,
  padding = 'md',
  ...rest
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  return (
    <div
      className={cn(
        'border-chariot-stroke bg-chariot-background-primary rounded-md border',
        paddingClasses[padding],
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
